import { Injectable } from '@angular/core';

import { paymentStatsHeaderList, paymentTypes, paymentTypeTitle } from 'app/constants';

import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable()
export class DataService {
  private subject = new Subject<any>();
  private clickEventSubject = new Subject<any>();
  private keyPressEventSubject = new Subject<any>();
  public poItemList = new ReplaySubject<any>();
  public stockItemdata = new ReplaySubject<any>();
  private appData;
  private globalSearchSubject = new Subject<string>();
  private qtqAddonSubject = new Subject<any>();
  private companyLocalizationSubject = new BehaviorSubject<boolean>(false);
  private techCustomerPrefferedLanguageSubject = new BehaviorSubject<string>('en');
  private POUpdatedSubject = new BehaviorSubject<boolean>(false);

  poItemIndex = null;
  checkTxt: string = 'Check';
  cash: string = 'Cash';
  credit: string = 'Credit';
  laborTxt: string = 'Labor';
  itemName: string = '';
  tableConfig = {};
  searchRoNumber: string = '';
  // check in labor drill down is item motor.
  isitemSourceMotor: boolean = false;
  supplierId: string = '';
  supplierPageSizes = {
    core: {
      page: 0,
      sort: '',
      order: 1,
    },
    itemReturn: {
      page: 0,
      sort: '',
      order: 1,
    },
    itemPurchase: {
      page: 0,
      sort: '',
      order: 1,
    },
  };

  driveTypeSelected: string = '';
  dataChanges = {
    customer: {
      dataChange: false,
    },
    vehicle: {
      updates: [],
    },
  };
  iFrameUrl: string = '';
  // data storage for edit vehicle flow
  editVehicle: any = {
    vehicles: null,
    transmissions: null,
    colors: null,
    driveType: null,
    mileage: null,
    selectedColor: null,
    selectedTransmission: null,
    selectedMileage: null,
    selectedVehicle: null,
    selectedDriveType: null,
    mileageValue: null,
    notes: null,
  };

  editTireStorage: any = {
    storageLocation: null,
    rimTypes: null,
    type: null,
    locations: null,
  };
  company: any = {};
  locationAddress: any = {};
  showQboModel: boolean = false;
  isCarfaxEnabled: boolean = false;
  isMotorEnabled: boolean = false;
  isPartsTechEnabled: boolean = false;
  isManualPartOrderingEnabled: boolean = false;
  isInventoryEnabled: boolean = false;
  isMarketingEnabled: boolean = false;
  isMarketingLeadAttributionEnabled: boolean = false;
  isFleetTaxOverRideEnabled: boolean = false;
  isChatEnabled: boolean = false;
  isQuickbooksConnected: boolean = false;
  isOnlinePaymentEnable: boolean = false;
  itemMovmentReport: boolean = false;
  isPayrixConnected: boolean = false;
  isDeferredServiceEnabled: boolean = false;
  isRepairDiagramEnabled: boolean = false;
  isAddressOnApptVisible: boolean = false;
  isSchedulePickupOn: boolean = false;
  isOrderHistoryEnabled: boolean = false;
  isROPrioritiesEnabled: boolean = false;
  isManualInvCodeEnabled: boolean = false;
  canUpdateInvoiceNumber: boolean = false;
  canEndRestrictedSession: boolean = false;
  canViewEditCommission: boolean = false;
  canRevertToEstimate: boolean = false;
  isServiceStickyHeader: boolean = false;
  isArAccountManagement: boolean = false;
  chargeAccounts: any;
  canRestoreDeleteRO: boolean = false;
  canFinalizedAdjustmentInvoices: boolean = false;
  isGoogleOnlineBookingEnabled: boolean = false;
  isReturnFeatureEnabled: boolean = false;
  attendanceLogEnabled: boolean = false;
  vinScannerEnabled: boolean = false;
  isTaxRateBreakdown: boolean = false;
  nexpartEnabled: boolean = false;
  isVinMandatory: boolean = false;
  isEnhancedGlobalSearchEnabled: boolean = false;
  partsTechEnabled: boolean = false;
  enableTaxRatesBreakdown: boolean = false;
  enableMandatoryVin: boolean = false;
  isMileageMandatory: boolean = false;
  isRegStateMandatory: boolean = false;
  isLicensePlateMandatory: boolean = false;
  isStatementZipFileEnabled: boolean = false;
  globalSearchIncludeArchivedOrders: boolean = false;
  isCompanyLoading: boolean = true;
  defaultMileageUnit: string = '';
  defaultPriority: any = null;
  taxPreAppliedFilters: any = null;
  feePreAppliedFilters: any = null;
  itemSoldPreAppliedFilters: any = null;
  marketingSettings: any = null;
  poItemListWithExsistingPo: any = [];
  accPayableTerms: any = [];
  isTireStorageEnabled: boolean = false;
  isPartsOrderingDisassociateEnabled: boolean = false;
  isMitchellIntegrationEnabled: boolean = false;
  isMitchell1EstimatorEnabled: boolean = false;
  isPartsOrdingCostEditabled: boolean = false;
  isPartsOrderingInvCheckEnabled: boolean = false;
  isFeeReportingEnabled: boolean = false;
  isFeeAssociationEnabled: boolean = false;
  isDiscountItemEnabled: boolean = false;
  isMultiLocationEnabled: boolean = false;
  isMarketingOptOutEnabled: boolean = false;
  isManualTechLogEnabled: boolean = false;
  isTechManualTechLogEnabled: boolean = false;
  isSQSEnabled: boolean = false;
  isSupplierProfileEnabled: boolean = false;
  isSendInspectionEnabled: boolean = false;
  profitabilityUseWorkedHours: boolean = false;
  isShortIoEnabled: boolean = false;
  isWorkAsTechEnabled: boolean = false;
  isInvCodeVisibleOnKanban: boolean = false;
  isTechSelfAssignUnassignService: boolean = false;
  isInvCodEqToEstCode: boolean = false;
  isAudibleNotificationsEnabled: boolean = false;
  isFluidSpecsEnabled: boolean = false;
  isFluidPartLookupTypeEnabled: boolean = false;
  isRoLevelFeeEnabled: boolean = false;
  isApptRequestPortalEnabled: boolean = false;
  isUnfillInspChecklistVisible: boolean = false;
  displayExternalServiceNotes: boolean = false;
  autoQboPostingFromPayLinkPayment: boolean = false;
  paymentSignatureOnlinePayment: boolean = false;
  isFloridaStateComplianceUpdates: boolean = false;
  isCAStateComplianceEnabled: boolean = false;
  isDisplayAuthorizationLogs: boolean = false;
  isCashDrawerReconciliation: boolean = false;
  isCashDrawerPending: boolean = false;
  isOpenInSameTabEnabled: boolean = false;
  isUserCenterEnabled: boolean = false;
  isSplitTechActuallBillableHrs: boolean = false;
  isJournalEntryEnabled: boolean = false;
  isSandboxIntegrationEnabled: boolean = false;
  isMarkPsDashboard: boolean = false;
  isInventoryReturnEnabled: boolean = false;
  isCoreCostManagementEnabled: boolean = false;
  isCustomerPaymentEnabled: boolean = false;
  currentShop: any = {};
  currentShopId: string = '';
  currentShopTz: string = '';
  partnerId: string = '';
  userEmail: string = '';
  businessSummaryReportInfo = {};
  shopsMap: any = {};
  warehouse: any = {};
  isTaxDetailsBreakDown: boolean = false;
  isFlatRateEnabled: boolean = false;
  accountPayablePayment: boolean = false;
  isLockOrderEnabled: boolean = false;
  baseTax: boolean = true;
  finalizeFilterBy: boolean = true;
  taxType: any = '';
  taxCode: any = '';
  paidStatus: any;
  isExportedToAP: any;
  isExportedToReturn: any;
  discountType: any;
  dateType: any = '';
  isCommissionPlanEnabled: boolean = false;
  isEnhancedTSEnabled: boolean = false;
  isMarkPartsDeliveredIndividuallyEnabled: boolean = false;
  isPreferredLocationsEnabled: boolean = false;
  isCommissionLabor: boolean = false;
  isCommissionParts: boolean = false;
  isCommissionTire: boolean = false;
  isCommissionTireStorage: boolean = false;
  isCommissionFees: boolean = false;
  isTireLookupEnabled: boolean = false;
  tireConnectInventoryPOsEnabled: boolean = false;
  isAdHocCommissionable: boolean = false;
  isSupportAdminAccount: boolean = false;
  showCommissionPlan: boolean = false;
  isShowPaymentInPdf: boolean = false;
  isShowLineItemDisInPdf: boolean = false;
  isEstimateDepositEnabled: boolean = false;
  isAutomatedFollowUpEnabled: boolean = false;
  isAutomatedFollowUpOnByCustomer: boolean = false;
  isTechnicianSummaryByAllServicesEnabled: boolean = false;
  isTrackMileageInAndOut: boolean = false;
  isMileageInAndOutEnabled: boolean = false;
  isCoreFilterEnabled: boolean = false;
  isCustomPoNumberEnabled: boolean = false;
  isTireHubEnabled: boolean = false;
  isGlobalCategoryEnabled: boolean = false;
  isItemCoreVisibleOnKanban: boolean = false;
  isBusinessSummaryReportEnabled: boolean = false;
  canSwitchLocation: boolean = false;
  canEditClassifications: boolean = false;
  canEditSalesCode: boolean = false;
  isSupplierReportEnabled: boolean = false;
  isCalculateChangeEnabled: boolean = false;
  isImprovedTechMotorGuidesEnabled: boolean = false;
  isGreyScaleThemeEnabled: boolean = false;
  isPoChangesAfterMarkDeliveredEnabled: boolean = false;
  isGlobalPayEnabled: boolean = false;
  isTireConnectEnabled: boolean = false;
  isTransferVehicleEnabled: boolean = false;
  isInvoiceLockEnabled: boolean = false;
  isDotNumberReqOnInv: boolean = false;
  isInvoiceLockOn: boolean = false;
  isPaidInvoiceLockOn: boolean = false;
  isGlobalPayConnected: boolean = false;
  isRepairLinkEnabled: boolean = false;
  isOnlineInvOrderEnabled: boolean = false;
  isOverrideCostWithTechRate: boolean = false;
  isMarkAsInventoryEnabled: boolean = false;
  isGainSightPXEnabled: boolean = false;
  isGlobalPaySwipeConnected: boolean = false;
  isAdminTechControlEnabled: boolean = false;
  updateItemSupplierBasedOnRecentPo: boolean = false;
  updateItemCostCannedAndFlatRatePO: boolean = false;
  isCustomerConcernEnabled: boolean = false;
  isAttributeBasedPricingEnable: boolean = false;
  isNewItemCategoriesEnable: boolean = true;
  preferredInventoryOnlineLookup: string = '';
  isSalesCodeEnabled: boolean = false;
  isTireStorage2Enabled: boolean = false;
  isDvi2Enabled: boolean = false;
  isMarketingEmailEnabled: boolean = false;
  isEnhancedEstimateAndInvoiceEnabled: boolean = false;
  isCreateCustomInspections: boolean = true;
  tableConfigSalesTrend: any = {};
  tableConfigFleet = {};
  tableConfigRegular = {};
  tableConfigReceivables = {};
  currentEmployeeDetails: any = {};
  lookupQuickSelection: any[] = [];
  sortField = '';
  sortOrder = 1;
  isItemSoldReportEnhancement: boolean = false;
  isCountryCanada: boolean = false;
  customerEmailRequired: boolean = false;
  customerPhoneRequired: boolean = false;
  isDVICannedNotesEnabled: boolean = false;
  isCheckCustomerType: boolean = false;
  addMediaToInspections: boolean = false;
  isQuickTireLookupEnabled: boolean = false;
  isUnifiedPartsOrderingDialogEnabled: boolean = false;
  isDVIAnnotationsEnabled: boolean = false;
  isPermanentRODeleteEnabled: boolean = false;
  isAdjustmentInvoicesEnabled: boolean = false;
  isCommissionVisibleForTechsServiceWriters: boolean = false;
  isAutoServiceAuthorizationEnabled: boolean = false;
  isAutoAuthorizeService: boolean = false;
  isRevenueRecognitionSettleEnabled: boolean = false;
  isChargeAccountEnabled: boolean = false;
  isUseOnlinePricing: boolean = false;
  isNewBusinessSummary: boolean = false;
  tableConfigTaxSummary = {};
  tableConfigItemSold = {};
  revenueRecognitionPaymentMethodsArray: any[] = [];
  isPOFieldsReqForDeliveryEnabled: boolean = false;
  isEditedPoAndOnlineOrderCostCoreEnabled: boolean = false;
  manualOrderTaxationSetting: any = {};
  revenueRecognitiondateType: string = '';
  isSplitDeliveriesEnabled: boolean = false;
  isPrimaryPaymentPayrix: boolean = false;
  isPrimaryPaymentGlobalPay: boolean = false;
  isHelperTechChecklistORNotes: boolean = false;
  isSubletTrackingEnabled: boolean = false;
  isPartialOrderingEnabled: boolean = false;
  poFieldRequiredOn: boolean = false;
  isFilterOnSublet: boolean = false;
  isPassThroughTaxEnable: boolean = false;
  isWriteOffEnable: boolean = false;
  isPricingManagementEnable: boolean = false;
  isPricingMatricesManagement: boolean = false;
  nonInventoryPosItems: boolean = false;
  customerAgingEndDate: string = '';
  changePaymentData: boolean = false;
  managePaymentTypesAndMethods: boolean = false;
  isPaymentDataPrivilgesEnabled: boolean = false;
  isRoyaltyPermissionEnabled: boolean = false;
  itemMovementReturnDateFilter: string = 'itemReturnDate';
  speedDialEnabled: boolean = false;
  isPartWarrantiesEnabled: boolean = false;
  checkWarrantyEligibility: boolean = false;
  isTireWarrantyPolicyEnabled: boolean = false;
  isCRMDashboardEnabled: boolean = false;
  isCountTaxExemptROAsNonTaxedEnable: boolean = false;
  isQTQAddOnEnable: boolean = false;
  isMotorGen2Enabled: boolean = false;
  isOilStickerImproved: boolean = false;
  excludeCoreCostInPOs: boolean = false;
  speedDialScriptWindowObject: any;
  isStockTransferEnabled: boolean = false;
  isQuickServiceEnabled: boolean = false;
  manualOrderPO: any[] = [];
  path = '';
  isLockedRO = false;
  isCompanyTextShow: boolean = false;
  isUpdatedCatalogPricingEnabled: boolean = false;
  isPartsTechPartsOrderingCartEnabled: boolean = false;
  isPartLookupModalPopUpInProgress: boolean = false;
  isFinalizedRo: boolean = false;
  isRoyaltyReportEnabled: boolean = false;
  isMidasRoyaltyReportsEnable: boolean = false;
  isInventoryManagementEnabled: boolean = false;
  canUpdateStockManually: boolean = false;
  isNewPartModalEnabled: boolean = false;
  isNewTireModalEnabled: boolean = false;
  isWarrantyNumberAddonEnabled: boolean = false;
  isFeeAndDiscountOnPOEnabled: boolean = false;
  finalizeType = [];
  thirdPartyAccount = [];
  dateTitle = '';
  isFilterByFinalizeDate: boolean = false;
  isMyFleetCenterEnabled: boolean = false;
  isNewMarketGroupFilterEnabled: boolean = false;
  isGoogleAddressSearchEnabled: boolean = false;
  isMyFleetCenterConnected: boolean = false;
  isAccountingExportsEnabled: boolean = false;
  isPermittedAccountingExportsEnabled: boolean = false;
  canUpdateCustVehMandatoryFields: boolean = false;
  isDisplayPaymentBannerEnabled: boolean = false;
  isCustomerVehicleMandatoryFieldsEnabled: boolean = false;
  isOrderRangeFilterEnabled: boolean = false;
  isMotorLookupEnabled: boolean = false;
  isMidasShop: boolean = false;
  isUpdateInventoryPO: boolean = false;
  companyLocalization: boolean = false;
  isSMSCampaignLimitEnabled: boolean = false;
  customerTechPrefferedLang: string = 'en';
  enterprise: string = '';
  finalizationTypeList = [];
  shopAccessesList = [];
  serviceCompleteDate: boolean = false;
  isCustomReportingEnabled:boolean = false
  customerMandatoryFields = {
    email: false,
    mobile: false,
    address: false,
  };
  langChangeSubject = new Subject<string>();
  isCreditSMSEnabled: boolean = false;
  itemsSoldReportSearchSubject$ = new BehaviorSubject<string>('');
  searchQuery = '';

  setCompanyLocalization(value: boolean) {
    this.companyLocalization = value;
    this.companyLocalizationSubject.next(value);
  }
  setTechCustomerPrefferedLanguage(value: string) {
    this.customerTechPrefferedLang = value.toLocaleLowerCase();
    this.techCustomerPrefferedLanguageSubject.next(value);
  }

  getTechCustomerPrefferedLanguage(): Observable<string> {
    return this.techCustomerPrefferedLanguageSubject.asObservable();
  }

  getCompanyLocalization(): Observable<boolean> {
    return this.companyLocalizationSubject.asObservable();
  }

  setPOUpdated(value: boolean) {
    this.POUpdatedSubject.next(value);
  }

  getPOUpdated(): Observable<boolean> {
    return this.POUpdatedSubject.asObservable();
  }

  // clearing values
  clearEditVehicle = () => {
    this.editVehicle = {
      vehicles: null,
      transmissions: null,
      colors: null,
      selectedColor: null,
      selectedTransmission: null,
      selectedVehicle: null,
      driveType: null,
      mileage: null,
      selectedMileage: null,
    };
  };

  // Passing Data to Chat Module

  customerData: any = {};
  // inspection tech initialName
  public techInititalName = '';

  /*  This flag is using in SettingsComponent, GeneralComponent, CompanyProfileComponent*/
  public isAddComponent: boolean = true;

  sendClickEvent = (data: any) => this.clickEventSubject.next(data);
  getClickEvent = (): Observable<any> => this.clickEventSubject.asObservable();

  sendKeyPressEvent = (data: any) => this.keyPressEventSubject.next(data);
  getKeyPressEvent = (): Observable<any> => this.keyPressEventSubject.asObservable();

  updateSearchEvent = (data: string) => this.globalSearchSubject.next(data);
  getSearchEvent = (): Observable<string> => this.globalSearchSubject.asObservable();

  updateqtqAddonEvent = (data: any) => this.qtqAddonSubject.next(data);
  getqtqAddonEvent = (): Observable<any> => this.qtqAddonSubject.asObservable();

  /**
   * @param  {any} data any
   * @returns {void}
   */
  sendData = (data: any) => this.subject.next({ data });

  /**
   * Clear Data
   */
  clearData = () => this.subject.next(null);
  /**
   * @returns {Observable<any>}
   */
  getData = (): Observable<any> => this.subject.asObservable();

  /**
   * @param  {any} data any
   * @returns {void}
   */
  sendAddData = (data: any) => (this.appData = data);

  /**
   * @returns {any}
   */
  getAppData = (): any => this.appData;

  /**
   * All types for data events
   * - update
   * - update
   */

  /**
   * Data for type update
   * @param  {string} component Which component needs to update
   * @param  {string} tab Which tab needs to update example: customer, vehicle
   * @param  {object} data Required data if any
   */
  typeUpdate(component, tab = null, data = null) {
    return { type: 'update', component, tab, data };
  }

  /**
   * Data for type add
   * @param  {string} component Which component needs to add
   * @param  {string} tab Which tab needs to add example: customer, vehicle
   * @param  {object} data Required data if any
   */
  typeAdd(component, tab = null, data = null) {
    return { type: 'add', component, tab, data };
  }

  /**
   * Data for type sidebar (sidebar open)
   * @param  {string} tab Which tab needs to update example: customer, vehicle
   * @param  {string} _id customer _id
   * @param  {string} fullName customer full name
   * @param  {object} data Required data if any
   */
  typeSidebar(tab, _id, fullName, data = null) {
    return { type: 'sidebar', tab, _id, fullName, data };
  }

  typeFleetOverride(tab, _id, fullName, data = null) {
    return { type: 'fleet-override', tab, _id, fullName, data };
  }

  typeFollowUp(openFrom: string, data: any) {
    return { type: 'follow-up-sidebar', openFrom, data };
  }

  typeTireStorageSideBar(openFrom: string, data: any) {
    return { type: 'tire-storage-sidedrawer', openFrom, data };
  }

  typeSupplierSideBar(tab, _id, fullName, data = null) {
    return { type: 'supplier-sidebar', tab, _id, fullName, data };
  }

  typeNotificationSideBar(tab, _id, fullName, data = null) {
    return { type: 'notification-sidebar', tab, _id, fullName, data };
  }

  /**
   * Data for type sidebar (sidebar open)
   * @param  {string} tab Which tab needs to update example: add customer, add vehicle
   * @param  {string} from from where this dialog is opening
   * @param  {string} _id customer _id
   * @param  {string} fullName customer full name
   * @param  {object} data Required data if any
   */
  typeDialog(tab, from, _id = null, fullName = null, data = null) {
    return { type: 'dialog', tab, from, _id, fullName, data };
  }

  /**
   * Data for type sidebar (sidebar open)
   * @param  {string} tab Which tab needs to update example: add customer, add vehicle
   * @param  {string} key name of the data key
   * @param  {object} data Required data
   */
  typePassData(key, data) {
    return { type: 'passdata', key, data };
  }

  /**
   * @param  {string} tab Which tab needs to update example: add customer, add vehicle
   * @param  {string} key name of the data key
   * @param  {object} data Required data
   */
  typeFilterData(key, data) {
    return { type: 'filterdata', key, data };
  }

  setEnterprise = (name: string) => {
    this.enterprise = name;
    this.isMidasShop = new RegExp('^midas$', 'i').test(this.enterprise);
  };
  getEnterprise = () => this.enterprise;

  updateTxt() {
    if (this.company && this.company.address && this.company.address.country === 'Canada') {
      this.checkTxt = 'Cheque';
      this.laborTxt = 'Labour';
      this.isCountryCanada = true;
      paymentTypeTitle.cheque = this.checkTxt;
      paymentTypes.forEach((payment, i) => {
        if (payment.value === 'cheque') {
          paymentTypes[i].label = `${this.checkTxt} / Bank`;
        }
      });
      paymentStatsHeaderList.forEach((payment, i) => {
        if (payment.value === 'cheque') {
          paymentStatsHeaderList[i].title = this.checkTxt;
        }
      });
    } else {
      this.checkTxt = 'Check';
      this.laborTxt = 'Labor';
      paymentTypeTitle.cheque = this.checkTxt;
      paymentTypes.forEach(({ value }, i) => {
        if (value === 'cheque') {
          paymentTypes[i].label = `${this.checkTxt} / Bank`;
        }
      });
      paymentStatsHeaderList.forEach(({ value }, i) => {
        if (value === 'cheque') {
          paymentStatsHeaderList[i].title = this.checkTxt;
        }
      });
    }
  }
}
